import React, { useState, useEffect} from "react";
import "./dashboard.css";
import Sidebar from "../../components/sidebar";
import PageHeader from "../../components/Header";
import { UserCount } from "../../sevices/account";
import { jobPostCount, UserLocationList } from "../../sevices/account";
import DashboardMap from "./dashboardMap";
import DashboardData from "./dashboardData";
import useUserRole from "../../components/UserRole.js";
import { Typography } from "@mui/material";

// CommonModal
const DashboardScreen = ({ currentMenu }) => {
  const { userRole, currentUser } = useUserRole();
  const [userCount, setUserCount] = useState("");
  const [postCount, setPostCount] = useState("");
  const [locationData, setLocationData] = useState([]);
  const [locationDatainitial, setLocationDatainitial] = useState({});
  const [loading, setLoading] = useState(false);
  const initialCenter = {
    lat: locationDatainitial?.latitude,
    lng: locationDatainitial?.longitude,
  };
  const [mapCenter, setMapCenter] = useState(initialCenter);

  const userCountData = async () => {
    setLoading(true);
    try {
      const response = await UserCount({});
      if (response?.status === 200) {
        setUserCount(response?.data);
        getJobPostCount();
      }
    } catch (error) {
      setLoading(false);
      console.log("ERR58R", error);
    }
  };

  const getJobPostCount = async () => {
    try {
      const response = await jobPostCount({});
      if (response?.status === 200) {
        setPostCount(response?.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    userCountData();
    getlocationDetails();
  }, []);
  const getlocationDetails = async () => {
    try {
      const response = await UserLocationList({});
      if (response?.status === 200) {
        setLocationData(response?.data?.details?.items);
        if (response?.data?.details?.items?.length > 0) {
          setLocationDatainitial(response?.data?.details?.items[0]);
        } else {
        }
      }
    } catch (error) {
      // setLoading(false)
    }
  };


  return (
    <div >
      <div className="page d-flex flex-row flex-column-fluid">
        <Sidebar />
        <div className="wrapper d-flex flex-column flex-row-fluid w-100 page-layout">
          <PageHeader />
          <div className="Page-inner-container" style={{marginTop: "-66px"}}>
            {/* <Typography
              variant="h4"
              component="h2"
              style={{
                color: "#333",
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              Dashboard
            </Typography> */}
            <div className='template-list-title'>
              <span style={{ fontSize: '22px', fontWeight: '600' }}>Dashboard</span>
            </div>
        
            <DashboardData />
            {userRole === 0 ? <DashboardMap /> : null}

          </div>

        </div>
      </div>
    </div>
  );
};

export default DashboardScreen;
